(() => {
  const root = document.querySelector('[data-ocp]');
  const source = window.OrliCharmPilotData;
  const data = window.OrliBuilderConfig?window.OrliBuilderConfig.prepare(source):source;
  if (!root || !data) return;
  if(root.hasAttribute('data-ocp-embedded')){
    const productRoot=root.closest('[id^="MainProduct--"]');
    const buy=productRoot?.querySelector('[id^="ProductSubmitButton"]');
    if(buy){buy.disabled=true;}
  }
  const dialog = root.querySelector('[data-ocp-dialog]');
  const grid = root.querySelector('[data-ocp-grid]');
  const styles = root.querySelector('[data-ocp-styles]');
  const confirm = root.querySelector('[data-ocp-confirm]');
  const reviewButton = root.querySelector('[data-ocp-review-button]');
  const review = root.querySelector('[data-ocp-review]');
  const state = {initial:null,birthstone:null};
  const config = {
    initial:{title:'Choose your initial',styleLabel:'Initial style',gridLabel:'Choose your letter',styles:['Uppercase','Lowercase'],groups:{Uppercase:'Uppercase Initial',Lowercase:'Lowercase Initial'},styleProperty:'Initial Style'},
    birthstone:{title:'Choose your birthstone',styleLabel:'Birthstone shape',gridLabel:'Choose your month',styles:['Rectangle','Round'],groups:{Rectangle:'Rectangle Birthstone',Round:'Round Birthstone'},styleProperty:'Birthstone Style '}
  };
  let kind = 'initial', draft = null, trigger = null;
  const make = (tag, cls, text) => {const el=document.createElement(tag);if(cls)el.className=cls;if(text!==undefined)el.textContent=text;return el;};
  const selectionText = item => item ? `${item.style} · ${item.value.label}` : '';
  const image = (value, alt, size=160) => {
    const img=make('img');
    const url=new URL(window.OrliPersonalisation?.resolveImage(value.image)||value.image,window.location.origin);
    if(url.hostname==='cdn.shopify.com')url.searchParams.set('width',String(size*2));
    img.src=url.href;img.alt=alt;img.loading='lazy';img.decoding='async';img.width=size;img.height=size;
    return img;
  };
  function updateDraft() {
    root.querySelector('[data-ocp-draft-summary]').textContent=draft.value?selectionText(draft):kind==='initial'?'Choose your letter above':'Choose your month above';
    confirm.disabled=!draft.value;
  }
  function renderGrid() {
    grid.replaceChildren();grid.dataset.kind=kind;
    const group=data.groups[config[kind].groups[draft.style]];
    for(const value of group.values.filter(v=>!v.hidden)){
      const btn=make('button','ocp-option');btn.type='button';btn.setAttribute('aria-label',value.label);btn.setAttribute('aria-pressed',String(draft.value?.id===value.id));
      btn.append(image(value,value.label),make('span','',value.label+(value.price_pence?' +'+pricing.format(value.price_pence):'')));btn.disabled=value.hidden;
      btn.addEventListener('click',()=>{draft.value=value;grid.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));updateDraft();});
      grid.append(btn);
    }
    updateDraft();
  }
  function renderStyles() {
    styles.replaceChildren();
    for(const style of enabledStyles(kind)){
      const btn=make('button','ocp-style',styleValue(kind,style)?.label||style);btn.type='button';btn.setAttribute('aria-pressed',String(style===draft.style));
      btn.addEventListener('click',()=>{if(draft.style===style)return;draft={style,value:null};renderStyles();renderGrid();});styles.append(btn);
    }
  }
  const parentGroup=k=>data.groups[k==='initial'?'Initial Style':'Birthstone Style'];
  const styleValue=(k,style)=>parentGroup(k)?.values.find(v=>(v.orli_original_label||v.label).trim()===style);
  const enabledStyles=k=>config[k].styles.filter(style=>{const v=styleValue(k,style),group=data.groups[config[k].groups[style]];return v&&!v.hidden&&group&&!group.disabled;});
  const enabledKinds=()=>['initial','birthstone'].filter(k=>!parentGroup(k)?.disabled&&enabledStyles(k).length);
  const pricing=window.OrliPersonalisation.priceController(root);
  let closing = false, closeTimer = null;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function finishClose() {
    clearTimeout(closeTimer);
    dialog.removeEventListener('animationend', onExitEnd);
    dialog.close();
    dialog.classList.remove('is-closing');
    document.documentElement.classList.remove('ocp-dialog-open');
    closing = false;
    trigger?.focus();
  }
  function onExitEnd(event) {
    if (event.target === dialog && event.animationName === 'ocp-drawer-out') finishClose();
  }
  function close() {
    if (!dialog.open || closing) return;
    if (reducedMotion.matches) {finishClose();return;}
    closing = true;
    dialog.style.setProperty('--ocp-close-from', getComputedStyle(dialog).transform);
    dialog.style.setProperty('--ocp-backdrop-from', getComputedStyle(dialog, '::backdrop').opacity);
    dialog.classList.add('is-closing');
    dialog.addEventListener('animationend', onExitEnd);
    closeTimer = setTimeout(finishClose, 420);
  }
  function sync() {
    let chosen=0;const enabled=enabledKinds();
    for(const k of enabled){
      const item=state[k],thumb=root.querySelector(`[data-ocp-thumb="${k}"]`);
      if(item){chosen++;thumb.replaceChildren(image(item.value,item.value.label,64));root.querySelector(`[data-ocp-summary="${k}"]`).textContent=selectionText(item);root.querySelector(`[data-ocp-action="${k}"]`).textContent='Edit';}
    }
    root.querySelector('[data-ocp-progress]').textContent=`${chosen} of ${enabled.length} chosen`;
    reviewButton.disabled=chosen===0;review.hidden=true;
    const properties={},paidSelections=[];let additional=0;
    for(const k of enabled)if(state[k]){
      properties[parentGroup(k).property]=styleValue(k,state[k].style)?.label||state[k].style;
      properties[data.groups[config[k].groups[state[k].style]].property]=state[k].value.label;
      const group=data.groups[config[k].groups[state[k].style]],value=state[k].value;if(value.price_pence){additional+=value.price_pence;paidSelections.push({key:JSON.stringify([data.set_id,group.property,value.id,'']),price:value.price_pence,units:1,properties:{[group.property]:value.label}});}
    }
    root.dataset.orderProperties=JSON.stringify(properties);
    root.dataset.selectionComplete=String(enabled.every(k=>!parentGroup(k).required||state[k]));
    root.dataset.paidSelections=JSON.stringify(paidSelections);
    root.dataset.additionalPrice=String(additional);pricing.set(additional);
    window.OrliPersonalisation?.syncForm(root);
  }
  root.querySelectorAll('[data-ocp-open]').forEach(btn=>btn.addEventListener('click',()=>{
    trigger=btn;kind=btn.dataset.ocpOpen;draft=state[kind]?{...state[kind]}:{style:enabledStyles(kind)[0],value:null};
    root.querySelector('[data-ocp-dialog-title]').textContent=config[kind].title;root.querySelector('[data-ocp-style-label]').textContent=config[kind].styleLabel;root.querySelector('[data-ocp-grid-label]').textContent=config[kind].gridLabel;
    confirm.textContent=kind==='initial'?'Use this initial':'Use this birthstone';renderStyles();renderGrid();dialog.classList.remove('is-closing');dialog.showModal();root.querySelector('.ocp-drawer-body').scrollTop=0;document.documentElement.classList.add('ocp-dialog-open');
  }));
  confirm.addEventListener('click',()=>{if(!draft.value)return;state[kind]={...draft};sync();close();});
  root.querySelector('[data-ocp-close]').addEventListener('click',close);
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
  dialog.addEventListener('close',()=>{clearTimeout(closeTimer);closing=false;dialog.classList.remove('is-closing');document.documentElement.classList.remove('ocp-dialog-open');});
  dialog.addEventListener('click',event=>{if(event.target===dialog)close();});
  reviewButton.addEventListener('click',()=>{
    if(!state.initial&&!state.birthstone)return;
    const list=root.querySelector('[data-ocp-review-items]');list.replaceChildren();
    for(const k of enabledKinds()){const item=state[k];if(!item)continue;const row=make('div','ocp-review-item');const text=make('div');text.append(make('strong','',k==='initial'?'Your initial':'Your birthstone'),make('span','',selectionText(item)));row.append(image(item.value,item.value.label,48),text);list.append(row);}
    review.hidden=false;review.focus();
  });
  root.querySelectorAll('[data-ocp-image]').forEach(btn=>btn.addEventListener('click',()=>{const img=root.querySelector('.ocp-main-image');img.removeAttribute('srcset');img.src=btn.dataset.ocpImage;root.querySelectorAll('[data-ocp-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));}));
  root.querySelectorAll('[data-ocp-open]').forEach(btn=>{
    const group=data.groups[btn.dataset.ocpOpen==='initial'?'Initial Style':'Birthstone Style'];
    const k=btn.dataset.ocpOpen;if(!enabledKinds().includes(k)){btn.hidden=true;return;}if(group.orli_label_override)btn.querySelector('strong').textContent=group.label;
    if(group.required)window.OrliPersonalisation.badge(btn.querySelector('strong'));
    btn.disabled=false;
  });
  if(window.OrliBuilderConfig)sync();
  root.dataset.ocpReady='true';
})();

/* ORLI merchant controls v1 */
